export default "__VITE_ASSET__to5HiMH7__"